import { InfoCard } from '../vtex-apps/store-components/InfoCard/InfoCard';
import SearchBar from '../vtex-apps/store-components/SearchBar/SearchBar';
import Menu from '../vtex-apps/menu/Menu/Menu';
import MenuItem from '../vtex-apps/menu/MenuItem/MenuItem';
import Minicart from '../vtex-apps/minicart/Minicart/Minicart';
import MinicartFixed from '../vtex-apps/minicart/MinicartFixed/MinicartFixed';
import { Footer } from '../vtex-apps/store-footer/Footer/Footer';
import { FlexLayout } from '../vtex-apps/flex-layout/FlexLayout/FlexLayout';
import Logo from '../vtex-apps/store-components/Logo/Logo';
import Login from '../vtex-apps/login/Login/Login';
import { Header } from '../vtex-apps/header/Header/Header';
import Image from '../vtex-apps/store-components/Image/Image';
import RichText from '../vtex-apps/rich-text/RichText/RichText';
import SliderLayout from '../vtex-apps/slider-layout/SliderLayout/SliderLayout';
import AddToCartButton from '../vtex-apps/add-to-cart-button/AddToCartButton/AddToCartButton';
import ProductSummaryImage from '../vtex-apps/product-summary/ProductSummaryImage/ProductSummaryImage';
import ProductSummaryName from '../vtex-apps/product-summary/ProductSummaryName/ProductSummaryName';
import ProductBrand from '../vtex-apps/store-components/ProductBrand/ProductBrand';
import ProductSummary from '../vtex-apps/product-summary/ProductSummary/ProductSummary';
import ProductPrice from '../vtex-apps/product-price/ProductPrice/ProductPrice';
import ShippingSimulator from '../vtex-apps/store-components/ShippingSimulator/ShippingSimulator';
import ProductSummaryList from '../vtex-apps/product-summary/ProductSummaryList/ProductSummaryList';
import RelatedProducts from '../vtex-apps/shelf/RelatedProducts/RelatedProducts';
import ProductIdentifier from '../vtex-apps/product-identifier/ProductIdentifier/ProductIdentifier';
import Share from '../vtex-apps/store-components/Share/Share';
import SkuSelector from '../vtex-apps/store-components/SkuSelector/SkuSelector';
import Wishlist from '../vtex-apps/peer/wishlist/Wishlist/Wishlist';
import ProductHighlights from '../vtex-apps/product-highlights/ProductHighlights/ProductHighlights';
import ProductHighlightText from '../vtex-apps/product-highlights/ProductHighlightText/ProductHighlightText';
import ProductHighlightWrapper from '../vtex-apps/product-highlights/ProductHighlightWrapper/ProductHighlightWrapper';
import ProductDescription from '../vtex-apps/store-components/ProductDescription/ProductDescription';
import ProductImages from '../vtex-apps/store-components/ProductImages/ProductImages';
import ProductQuantity from '../vtex-apps/product-quantity/ProductQuantity/ProductQuantity';
import Breadcrumb from '../vtex-apps/breadcrumb/Breadcrumb/Breadcrumb';
import Submenu from '../vtex-apps/menu/Submenu/Submenu';
import SubmenuAccordion from '../vtex-apps/menu/SubmenuAccordion/SubmenuAccordion';
import StickyLayout from '../vtex-apps/sticky-layout/StickyLayout/StickyLayout';
import { SearchResultLayout } from '../vtex-apps/search-result/SearchResultLayout/SearchResultLayout';
//import especial, já que é um handle mas será usado como wrapper para os itens
import HeaderItem from '../vtex-apps/header/Header/handles/HeaderItem';
import ProductInstallments from '../vtex-apps/product-price/ProductInstallments/ProductInstallments';
import ProductSellingPrice from '../vtex-apps/product-price/ProductSellingPrice/ProductSellingPrice';
import ProductListPrice from '../vtex-apps/product-price/ProductListPrice/ProductListPrice';
import ProductPriceSavings from '../vtex-apps/product-price/ProductPriceSavings/ProductPriceSavings';
import NewsletterForm from '../vtex-apps/store-newsletter/NewsletterForm/NewsletterForm';
import NewsletterCheckboxConfirmation from '../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/NewsletterCheckboxConfirmation';
import NewsletterInputEmail from '../vtex-apps/store-newsletter/NewsletterInputEmail/NewsletterInputEmail';
import NewsletterInputName from '../vtex-apps/store-newsletter/NewsletterInputName/NewsletterInputName';
import NewsletterSubmit from '../vtex-apps/store-newsletter/NewsletterSubmit/NewsletterSubmit';
import AcceptedPaymentMethods from '../vtex-apps/store-footer/AcceptedPaymentMethods/AcceptedPaymentMethods';
import Drawer from '../vtex-apps/store-drawer/Drawer/Drawer';
import DrawerHeader from '../vtex-apps/store-drawer/DrawerHeader/DrawerHeader';
import ProductName from '../vtex-apps/store-components/ProductName/ProductName';
import SocialNetwork from '../vtex-apps/store-footer/SocialNetwork/SocialNetwork';
import StackLayout from '../vtex-apps/stack-layout/StackLayout/StackLayout';
import ProductSpecification from '../vtex-apps/product-specification/ProductSpecification/ProductSpecification';
import ProductSpecificationGroup from '../vtex-apps/product-specification/ProductSpecificationGroup/ProductSpecificationGroup';
import ProductSpecificationText from '../vtex-apps/product-specification/ProductSpecificationText/ProductSpecificationText';
import ProductSpecificationValues from '../vtex-apps/product-specification/ProductSpecificationValues/ProductSpecificationValues';
import FilterNavigatorV3 from '../vtex-apps/search-result/FilterNavigatorV3/FilterNavigatorV3';
import SearchContent from '../vtex-apps/search-result/SearchContent/SearchContent';
import Gallery from '../vtex-apps/search-result/Gallery/Gallery';
import SearchTitleV2 from '../vtex-apps/search-result/SearchTitleV2/SearchTitleV2';
import TotalProductsV2 from '../vtex-apps/search-result/TotalProductsV2/TotalProductsV2';
import OrderByV2 from '../vtex-apps/search-result/OrderByV2/OrderByV2';
import DrawerCloseButton from '../vtex-apps/store-drawer/DrawerCloseButton/DrawerCloseButton';
import DisclosureContent from '../vtex-apps/disclosure-layout/DisclosureContent/DisclosureContent';
import DisclosureLayout from '../vtex-apps/disclosure-layout/DisclosureLayout/DisclosureLayout';
import DisclosureLayoutGroup from '../vtex-apps/disclosure-layout/DisclosureLayoutGroup/DisclosureLayoutGroup';
import DisclosureStateIndicator from '../vtex-apps/disclosure-layout/DisclosureStateIndicator/DisclosureStateIndicator';
import DisclosureTrigger from '../vtex-apps/disclosure-layout/DisclosureTrigger/DisclosureTrigger';
import MinicartBaseContent from '../vtex-apps/minicart/MinicartBaseContent/MinicartBaseContent';
import TabLayout from '../vtex-apps/tab-layout/TabLayout/TabLayout';
import TabList from '../vtex-apps/tab-layout/TabList/TabList';
import TabListItem from '../vtex-apps/tab-layout/TabListItem/TabListItem';
import TabContent from '../vtex-apps/tab-layout/TabContent/TabContent';
import TabContentItem from '../vtex-apps/tab-layout/TabContentItem/TabContentItem';
import Link from '../vtex-apps/Link/Link/Link';
import ProductRatingInline from '../vtex-apps/peer/reviews-and-ratings/ProductRatingInline/ProductRatingInline';
import ResponsiveLayoutDesktop from '../vtex-apps/responsive-layout/ResponsiveLayoutDesktop/ResponsiveLayoutDesktop';
import ResponsiveLayoutMobile from '../vtex-apps/responsive-layout/ResponsiveLayoutMobile/ResponsiveLayoutMobile';
import InfoCardList from '../vtex-apps/info-card-list/InfoCardList/InfoCardList';
import StoreImageList from '../vtex-apps/store-image-list/StoreImageList/StoreImageList';
import { ModalActionsClose } from '../vtex-apps/modal-layout/ModalActions/ModalActions';
import ModalLayout from '../vtex-apps/modal-layout/ModalLayout/ModalLayout';
import ModalTrigger from '../vtex-apps/modal-layout/ModalTrigger/ModalTrigger';
import ModalHeader from '../vtex-apps/modal-layout/ModalHeader/ModalHeader';
import ModalContent from '../vtex-apps/modal-layout/ModalContent/ModalContent';
import Reviews from '../vtex-apps/peer/reviews-and-ratings/Reviews/Reviews';
import CompreJunto from '../vtex-apps/BuyTogether/CompreJunto';
import SearchNotFoundLayout from '../vtex-apps/search-result/SearchNotFoundLayout/SearchNotFoundLayout';
import NotFound from '../vtex-apps/search-result/NotFound/NotFound';
import ConditionLayoutProduct from '../vtex-apps/ConditionLayoutProduct/ConditionLayoutProduct';
import AvailabilityNotify from '../vtex-apps/AvailabilityNotify/AvailabilityNotify';
import ListContextRenderer from '../vtex-apps/list-context/ListContextRenderer/ListContextRenderer';
import BackToTopButton from '../vtex-apps/store-components/BackToTopButton/BackToTopButton';
import VisibilityLayout from '../vtex-apps/VisibilityLayout/VisibilityLayout';
import DispositionLayout from '../vtex-apps/peer/DispositionLayout/DispositionLayout';
import Video from '../vtex-apps/Video/Video';
import ProductSpotPrice from '../vtex-apps/product-price/ProductSpotPrice/ProductSpotPrice';
import ProductGifts from '../vtex-apps/product-gifts/ProductGifts/ProductGifts';
import GiftText from '../vtex-apps/product-gifts/GiftText/GiftText';
import GiftName from '../vtex-apps/product-gifts/GiftName/GiftName';
import ProductGiftList from '../vtex-apps/product-gifts/ProductGiftList/ProductGiftList';
import GiftImage from '../vtex-apps/product-gifts/GiftImage/GiftImage';
import GiftDescription from '../vtex-apps/product-gifts/GiftDescription/GiftDescription';
import ProductInstallmentsList from '../vtex-apps/product-price/ProductInstallmentsList/ProductInstallmentsList';
import ProductInstallmentsListItem from '../vtex-apps/product-price/ProductInstallmentsListItem/ProductInstallmentsListItem';
import LinkSeller from '../vtex-apps/seller-selector/LinkSeller/LinkSeller';
import SellerTable from '../vtex-apps/seller-selector/SellerTable/SellerTable';
import SellerSimulateShipping from '../vtex-apps/seller-selector/SellerSimulateShipping/SellerSimulateShipping';
import SellerHead from '../vtex-apps/seller-selector/SellerHead/SellerHead';
import SellerHeadCell from '../vtex-apps/seller-selector/SellerHeadCell/SellerHeadCell';
import SellerBody from '../vtex-apps/seller-selector/SellerBody/SellerBody';
import SellerRow from '../vtex-apps/seller-selector/SellerRow/SellerRow';
import SellerName from '../vtex-apps/seller-selector/SellerName/SellerName';
import SellerPrice from '../vtex-apps/seller-selector/SellerPrice/SellerPrice';
import SellerShipping from '../vtex-apps/seller-selector/SellerShipping/SellerShipping';
import SellerPriceWithShipping from '../vtex-apps/seller-selector/SellerPriceWithShipping/SellerPriceWithShipping';
import SellerAddToCart from '../vtex-apps/seller-selector/SellerAddToCart/SellerAddToCart';
import TabListItemChildren from '../vtex-apps/tab-layout/TabListItemChildren/TabListItemChildren';
import Form from '../vtex-apps/store-form/Form';
import FormInputCheckbox from '../vtex-apps/store-form/FormInputCheckbox';
import FormInputDropdown from '../vtex-apps/store-form/FormInputDropdown';
import FormInputRadiogroup from '../vtex-apps/store-form/FormInputRadiogroup';
import FormInputTextArea from '../vtex-apps/store-form/FormInputTextArea';
import FormInputText from '../vtex-apps/store-form/FormInputText';
import FormFieldGroup from '../vtex-apps/store-form/FormFieldGroup';
import FormInputUpload from '../vtex-apps/store-form/FormInputUpload';
import FormSubmit from '../vtex-apps/store-form/FormSubmit';
import FormSuccess from '../vtex-apps/store-form/FormSuccess';
import MegaMenu from '../vtex-apps/mega-menu/Wrapper';
import MegaMenuGoBackBtn from '../vtex-apps/mega-menu/GoBackButton';
import MegaMenuTriggerBtn from '../vtex-apps/mega-menu/TriggerButton';
import SearchFetchPrevious from '../vtex-apps/search-result/SearchFetchPrevious/SearchFetchPrevious';
import SearchFetchMore from '../vtex-apps/search-result/SearchFetchMore/SearchFetchMore';
import OverlayLayout from '../vtex-apps/overlay-layout/OverlayLayout';
import OverlayTrigger from '../vtex-apps/overlay-layout/OverlayTrigger';
import ProductSummarySkuSelector from '../vtex-apps/product-summary/ProductSummarySkuSelector/ProductSummarySkuSelector';
import ProductSellerName from '../vtex-apps/product-price/ProductSellerName/ProductSellerName';

import {
	FlexLayoutRow as FlexLayoutRowProps,
	FlexLayoutCol as FlexLayoutColProps,
} from '../vtex-apps/flex-layout/FlexLayout/default';
import { InfoCard as InfoCardProps } from '../vtex-apps/store-components/InfoCard/default';
import { ProductPrice as ProductPriceProps } from '../vtex-apps/product-price/ProductPrice/default';
import { SearchBar as SearchBarProps } from '../vtex-apps/store-components/SearchBar/default';
import { Logo as LogoProps } from '../vtex-apps/store-components/Logo/default.js';
import { Login as LoginProps } from '../vtex-apps/login/Login/default.js';
import { Minicart as MinicartProps } from '../vtex-apps/minicart/Minicart/default';
import { MinicartFixed as MinicartFixedProps } from '../vtex-apps/minicart/MinicartFixed/default';
import { AcceptedPaymentMethods as AcceptedPaymentMethodsProps } from '../vtex-apps/store-footer/AcceptedPaymentMethods/default';
import { Image as ImageProps } from '../vtex-apps/store-components/Image/default';
import { RichText as RichTextProps } from '../vtex-apps/rich-text/RichText/default';
import { Menu as MenuProps } from '../vtex-apps/menu/Menu/default';
import { MenuItem as MenuItemProps } from '../vtex-apps/menu/MenuItem/default';
import { ProductSummaryImage as ProductSummaryImageProps } from '../vtex-apps/product-summary/ProductSummaryImage/default';
import { AddToCartButton as AddToCartButtonProps } from '../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { ProductSummaryName as ProductSummaryNameProps } from '../vtex-apps/product-summary/ProductSummaryName/default';
import { ProductBrand as ProductBrandProps } from '../vtex-apps/store-components/ProductBrand/default';
import { ProductSummary as ProductSummaryProps } from '../vtex-apps/product-summary/ProductSummary/default';
import { NewsletterSubmit as NewsletterSubmitProps } from '../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { NewsletterInputEmail as NewsletterInputEmailProps } from '../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterInputName as NewsletterInputNameProps } from '../vtex-apps/store-newsletter/NewsletterInputName/default';
import { NewsletterCheckboxConfirmation as NewsletterCheckboxConfirmationProps } from '../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/default';
import { NewsletterForm as NewsletterFormProps } from '../vtex-apps/store-newsletter/NewsletterForm/default';
import { ShippingSimulator as ShippingSimulatorProps } from '../vtex-apps/store-components/ShippingSimulator/default';
import { ResponsiveLayoutDesktop as ResponsiveLayoutDesktopProps } from '../vtex-apps/responsive-layout/ResponsiveLayoutDesktop/default';
import { ResponsiveLayoutMobile as ResponsiveLayoutMobileProps } from '../vtex-apps/responsive-layout/ResponsiveLayoutMobile/default';
import { ConditionLayoutProduct as ConditionLayoutProductProps } from '../vtex-apps/ConditionLayoutProduct/default';
import { ProductIdentifier as ProductIdentifierProps } from '../vtex-apps/product-identifier/ProductIdentifier/default';
import { Share as ShareProps } from '../vtex-apps/store-components/Share/default';
import { SkuSelector as SkuSelectorProps } from '../vtex-apps/store-components/SkuSelector/default';
import { Wishlist as WishlistProps } from '../vtex-apps/peer/wishlist/Wishlist/default.js';
import { ProductHighlights as ProductHighlightsProps } from '../vtex-apps/product-highlights/ProductHighlights/default';
import { ProductHighlightText as ProductHighlightTextProps } from '../vtex-apps/product-highlights/ProductHighlightText/default';
import { ProductHighlightWrapper as ProductHighlightWrapperProps } from '../vtex-apps/product-highlights/ProductHighlightWrapper/default';
import { ProductDescription as ProductDescriptionProps } from '../vtex-apps/store-components/ProductDescription/default';
import { ProductImages as ProductImagesProps } from '../vtex-apps/store-components/ProductImages/default';
import { ProductQuantity as ProductQuantityProps } from '../vtex-apps/product-quantity/ProductQuantity/default';
import { Submenu as SubmenuProps } from '../vtex-apps/menu/Submenu/default';
import { SubmenuAccordion as SubmenuAccordionProps } from '../vtex-apps/menu/SubmenuAccordion/default';
import { ProductInstallments as ProductInstallmentsProps } from '../vtex-apps/product-price/ProductInstallments/default';
import { ProductSellingPrice as ProductSellingPriceProps } from '../vtex-apps/product-price/ProductSellingPrice/default';
import { ProductListPrice as ProductListPriceProps } from '../vtex-apps/product-price/ProductListPrice/default';
import { ProductPriceSavings as ProductPriceSavingsProps } from '../vtex-apps/product-price/ProductPriceSavings/default';
import { Drawer as DrawerProps } from '../vtex-apps/store-drawer/Drawer/default';
import { DrawerHeader as DrawerHeaderProps } from '../vtex-apps/store-drawer/DrawerHeader/default';
import { ProductName as ProductNameProps } from '../vtex-apps/store-components/ProductName/default';
import { SocialNetwork as SocialNetworkProps } from '../vtex-apps/store-footer/SocialNetwork/default';
import { StackLayout as StackLayoutProps } from '../vtex-apps/stack-layout/StackLayout/default';
import { ProductSpecification as ProductSpecificationProps } from '../vtex-apps/product-specification/ProductSpecification/default';
import { ProductSpecificationGroup as ProductSpecificationGroupProps } from '../vtex-apps/product-specification/ProductSpecificationGroup/default';
import { ProductSpecificationText as ProductSpecificationTextProps } from '../vtex-apps/product-specification/ProductSpecificationText/default';
import { ProductSpecificationValues as ProductSpecificationValuesProps } from '../vtex-apps/product-specification/ProductSpecificationValues/default';
import { StoreImageList as StoreImageListProps } from '../vtex-apps/store-image-list/StoreImageList/default';
import { DisclosureContent as DisclosureContentProps } from '../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout as DisclosureLayoutProps } from '../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureLayoutGroup as DisclosureLayoutGroupProps } from '../vtex-apps/disclosure-layout/DisclosureLayoutGroup/default';
import { DisclosureStateIndicator as DisclosureStateIndicatorProps } from '../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { DisclosureTrigger as DisclosureTriggerProps } from '../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { MinicartBaseContent as MinicartBaseContentProps } from '../vtex-apps/minicart/MinicartBaseContent/default';
import { TabLayout as TabLayoutProps } from '../vtex-apps/tab-layout/TabLayout/default';
import { TabList as TabListProps } from '../vtex-apps/tab-layout/TabList/default';
import { TabListItem as TabListItemProps } from '../vtex-apps/tab-layout/TabListItem/default';
import { TabContent as TabContentProps } from '../vtex-apps/tab-layout/TabContent/default';
import { TabContentItem as TabContentItemProps } from '../vtex-apps/tab-layout/TabContentItem/default';
import { Link as LinkProps } from '../vtex-apps/Link/Link/default';
import { ProductRatingInline as ProductRatingInlineProps } from '../vtex-apps/peer/reviews-and-ratings/ProductRatingInline/default';
import { InfoCardList as InfoCardListProps } from '../vtex-apps/info-card-list/InfoCardList/default';
import { ModalTrigger as ModalTriggerProps } from '../vtex-apps/modal-layout/ModalTrigger/default';
import { ModalLayout as ModalLayoutProps } from '../vtex-apps/modal-layout/ModalLayout/default';
import { ModalHeader as ModalHeaderProps } from '../vtex-apps/modal-layout/ModalHeader/default';
import { ModalContent as ModalContentProps } from '../vtex-apps/modal-layout/ModalContent/default';
import { ModalActionsClose as ModalActionsCloseProps } from '../vtex-apps/modal-layout/ModalActions/default';
import { Reviews as ReviewsProps } from '../vtex-apps/peer/reviews-and-ratings/Reviews/default';
import { BuyTogether as BuyTogetherProps } from '../vtex-apps/BuyTogether/default';
import { SearchNotFoundLayout as SearchNotFoundLayoutProps } from '../vtex-apps/search-result/SearchNotFoundLayout/default';
import { NotFound as NotFoundProps } from '../vtex-apps/search-result/NotFound/default';
import { AvailabilityNotify as AvailabilityNotifyProps } from '../vtex-apps/AvailabilityNotify/default';
import { ListContextRenderer as ListContextRendererProps } from '../vtex-apps/list-context/ListContextRenderer/default';
import { BackToTopButton as BackToTopButtonProps } from '../vtex-apps/store-components/BackToTopButton/default';
import { VisibilityLayout as VisibilityLayoutProps } from '../vtex-apps/VisibilityLayout/default';
import { DispositionLayout as DispositionLayoutProps } from '../vtex-apps/peer/DispositionLayout/default';
import { Video as VideoProps } from '../vtex-apps/Video/default';
import { ProductSpotPrice as ProductSpotPriceProps } from '../vtex-apps/product-price/ProductSpotPrice/default';
import { GiftDescription as GiftDescriptionProps } from '../vtex-apps/product-gifts/GiftDescription/default';
import { ProductGifts as ProductGiftsProps } from '../vtex-apps/product-gifts/ProductGifts/default';
import { GiftText as GiftTextProps } from '../vtex-apps/product-gifts/GiftText/default';
import { GiftImage as GiftImageProps } from '../vtex-apps/product-gifts/GiftImage/default';
import { ProductGiftList as ProductGiftListProps } from '../vtex-apps/product-gifts/ProductGiftList/default';
import { GiftName as GiftNameProps } from '../vtex-apps/product-gifts/GiftName/default';
import { ProductInstallmentsList as ProductInstallmentsListProps } from '../vtex-apps/product-price/ProductInstallmentsList/default';
import { ProductInstallmentsListItem as ProductInstallmentsListItemProps } from '../vtex-apps/product-price/ProductInstallmentsListItem/default';
import { LinkSeller as LinkSellerProps } from '../vtex-apps/seller-selector/LinkSeller/default';
import { SellerTable as SellerTableProps } from '../vtex-apps/seller-selector/SellerTable/default';
import { SellerSimulateShipping as SellerSimulateShippingProps } from '../vtex-apps/seller-selector/SellerSimulateShipping/default';
import { SellerHead as SellerHeadProps } from '../vtex-apps/seller-selector/SellerHead/default';
import { SellerHeadCell as SellerHeadCellProps } from '../vtex-apps/seller-selector/SellerHeadCell/default';
import { SellerBody as SellerBodyProps } from '../vtex-apps/seller-selector/SellerBody/default';
import { SellerRow as SellerRowProps } from '../vtex-apps/seller-selector/SellerRow/default';
import { SellerName as SellerNameProps } from '../vtex-apps/seller-selector/SellerName/default';
import { SellerPrice as SellerPriceProps } from '../vtex-apps/seller-selector/SellerPrice/default';
import { SellerShipping as SellerShippingProps } from '../vtex-apps/seller-selector/SellerShipping/default';
import { SellerPriceWithShipping as SellerPriceWithShippingProps } from '../vtex-apps/seller-selector/SellerPriceWithShipping/default';
import { SellerAddToCart as SellerAddToCartProps } from '../vtex-apps/seller-selector/SellerAddToCart/default';
import { TabListItemChildren as TabListItemChildrenProps } from '../vtex-apps/tab-layout/TabListItemChildren/default';
import { Form as FormProps } from '../vtex-apps/store-form/FormDefault';
import { FormInputCheckbox as FormInputCheckboxProps } from '../vtex-apps/store-form/FormInputCheckboxDefault';
import { FormInputDropdown as FormInputDropdownProps } from '../vtex-apps/store-form/FormInputDropdownDefault';
import { FormInputRadiogroup as FormInputRadiogroupProps } from '../vtex-apps/store-form/FormInputRadioGroupDefault';
import { FormInputTextarea as FormInputTextareaProps } from '../vtex-apps/store-form/FormInputTextareaDefault';
import { FormInputText as FormInputTextProps } from '../vtex-apps/store-form/FormInputTextDefault';
import { FormFieldGroup as FormFieldGroupProps } from '../vtex-apps/store-form/FormFieldGroupDefault';
import { FormInputUpload as FormInputUploadProps } from '../vtex-apps/store-form/FormInputUploadDefault';
import { FormSubmit as FormSubmitProps } from '../vtex-apps/store-form/FormSubmitDefault';
import { FormSuccess as FormSuccessProps } from '../vtex-apps/store-form/FormSuccessDefault';
import { MegaMenu as MegaMenuProps } from '../vtex-apps/mega-menu/default';
import { MegaMenuGoBackBtn as MegaMenuGoBackBtnProps } from '../vtex-apps/mega-menu/defaultGoBack';
import { MegaMenuTriggerBtn as MegaMenuTriggerBtnProps } from '../vtex-apps/mega-menu/defaultTrigger';
import { SearchFetchMore as SearchFetchMoreProps } from '../vtex-apps/search-result/SearchFetchMore/default';
import { SearchFetchPrevious as SearchFetchPreviousProps } from '../vtex-apps/search-result/SearchFetchPrevious/default';
import { OverlayLayout as OverlayLayoutProps } from '../vtex-apps/overlay-layout/overlayLayoutDefault';
import { OverlayTrigger as OverlayTriggerProps } from '../vtex-apps/overlay-layout/overlayTriggerDefault';
import { ProductSummarySkuSelector as ProductSummarySkuSelectorProps } from '../vtex-apps/product-summary/ProductSummarySkuSelector/default';
import { ProductSellerName as ProductSellerNameProps } from '../vtex-apps/product-price/ProductSellerName/default';
import { Breadcrumb as BreadcrumbProps } from '../vtex-apps/breadcrumb/Breadcrumb/default';

//TEMPLATES
import HeaderDesktopTemplates, {
	HeaderDesktop as HeaderDesktopProps,
} from '../templates/components/HeaderDesktop/templates';
import HeaderMobileTemplates, {
	HeaderMobile as HeaderMobileProps,
} from '../templates/components/HeaderMobile/templates';
import FooterDesktopTemplates, {
	FooterDesktop as FooterDesktopProps,
} from '../templates/components/FooterDesktop/templates';
import ProductDescriptionGroupTemplates, {
	ProductDescriptionGroup as ProductDescriptionGroupProps,
} from '../templates/components/ProductDescriptionGroup/templates';
import FooterMobileTemplates, {
	FooterMobile as FooterMobileProps,
} from '../templates/components/FooterMobile/templates';
import ProductSpecificationSectionTemplates, {
	ProductSpecificationSection as ProductSpecificationSectionProps,
} from '../templates/components/ProductSpecificationSection/templates';
import BannerSectionGroupTemplates, {
	BannerSectionGroup as BannerSectionGroupProps,
} from '../templates/components/BannerSectionGroup/templates';
import RichTextVideoTemplates, {
	RichTextVideo as RichTextVideoProps,
} from '../templates/components/RichTextVideo/templates';
import TipbarGroupTemplates, { TipbarGroup } from '../templates/components/TipbarGroup/templates';
import ProductImagesDetailsTemplates, {
	ProductImagesDetailsGroup,
} from '../templates/components/ProductImagesDetailsGroup/templates';
import BrandGroupTemplates, { BrandGroup as BrandGroupProps } from '../templates/components/BrandGroup/templates';
import TopHeaderTemplates, { TopHeader as TopHeaderProps } from '../templates/components/TopHeader/templates';
import NewsletterTemplates, { Newsletter as NewsletterProps } from '../templates/components/Newsletter/templates';
import BreadcrumbGroupTemplates, {
	BreadcrumbGroup as BreadcrumbGroupProps,
} from '../templates/components/BreadcrumbGroup/templates';
import StoreMenuDesktopTemplates, {
	StoreMenuDesktop as StoreMenuDesktopProps,
} from '../templates/components/StoreMenuDesktop/templates';
import StoreMenuMobileTemplates, {
	StoreMenuMobile as StoreMenuMobileProps,
} from '../templates/components/StoreMenuMobile/templates';
import SliderLayoutTemplates, {
	SliderLayout as SliderLayoutProps,
} from '../templates/components/SliderLayout/templates';
import SearchResultLayoutDesktopTemplates, {
	SearchResultLayoutDesktop as SearchResultLayoutDesktopProps,
} from '../templates/components/SearchResultLayoutDesktop/templates';
import SearchResultLayoutMobileTemplates, {
	SearchResultLayoutMobile as SearchResultLayoutMobileProps,
} from '../templates/components/SearchResultLayoutMobile/templates';
import { FilterNavigatorV3 as FilterNavigatorV3Props } from '../vtex-apps/search-result/FilterNavigatorV3/default';
import { SearchContent as SearchContentProps } from '../vtex-apps/search-result/SearchContent/default';
import { Gallery as GalleryProps } from '../vtex-apps/search-result/Gallery/default';
import { SearchTitleV2 as SearchTitleV2Props } from '../vtex-apps/search-result/SearchTitleV2/default';
import { TotalProductsV2 as TotalProductsV2Props } from '../vtex-apps/search-result/TotalProductsV2/default';
import { OrderByV2 as OrderByV2Props } from '../vtex-apps/search-result/OrderByV2/default';
import ProductSummaryListTemplates, {
	ProductSummaryList as ProductSummaryListProps,
} from '../templates/components/ProductSummaryList/templates';
import ProductSummaryShelfTemplates, {
	ProductSummaryShelf as ProductSummaryShelfProps,
} from '../templates/components/ProductSummaryShelf/templates';
import { DrawerCloseButton as DrawerCloseButtonProps } from '../vtex-apps/store-drawer/DrawerCloseButton/default';
import ModalNewsletterTemplates, {
	ModalNewsletter as ModalNewsletterProps,
} from '../templates/components/ModalNewsletter/templates';
import MinicartGroupTemplates, {
	MinicartGroup as MinicartGroupProps,
} from '../templates/components/MinicartGroup/templates';
import InstitutionalGroupTemplates, {
	InstitutionalGroup as InstitutionalGroupProps,
} from '../templates/components/InstitutionalGroup/templates';
import RichTextRowTemplates, { RichTextRow as RichTextRowProps } from '../templates/components/RichTextRow/templates';
import RelatedProductsTemplates, {
	RelatedProducts as RelatedProductsProps,
} from '../templates/components/RelatedProducts/templates';
import ReviewsGroupTemplates, {
	ReviewsGroup as ReviewsGroupProps,
} from '../templates/components/ReviewsGroup/templates';
import BuyTogetherTemplates, {
	BuyTogetherGroup as BuyTogetherGroupProps,
} from '../templates/components/BuyTogetherGroup/templates';
import SearchNotFoundGroupTemplates, {
	SearchNotFoundGroup as SearchNotFoundGroupProps,
} from '../templates/components/SearchNotFoundGroup/templates';
import VideoGroupTemplates, { VideoGroup as VideoGroupProps } from '../templates/components/VideoGroup/templates';
import SellerSelectorTemplates, {
	SellerSelector as SellerSelectorProps,
} from '../templates/components/SellerSelector/templates';
//reviews and ratings
import RatingSummary from '../vtex-apps/peer/reviews-and-ratings/RatingSummary/RatingSummary';
import { RatingSummary as RatingSummaryProps } from '../vtex-apps/peer/reviews-and-ratings/RatingSummary/default';

//ICONS
import {
	IconCart as IconCartProps,
	IconCaret as IconCaretProps,
	IconDelete as IconDeleteProps,
	IconClose as IconCloseProps,
	Icon as IconProps,
} from '../vtex-apps/icons/default';
import IconCart from '../vtex-apps/icons/IconCart';
import IconCaret from '../vtex-apps/icons/IconCaret';
import IconDelete from '../vtex-apps/icons/IconDelete';
import IconClose from '../vtex-apps/icons/IconClose';
import Icon from '../vtex-apps/icons/Icon';

const { Row, Col } = FlexLayout;
const { Desktop: HeaderDesktop, Mobile: HeaderMobile } = Header;
const { Desktop: FooterDesktop, Mobile: FooterMobile } = Footer;
const { Desktop: SearchResultLayoutDesktop, Mobile: SearchResultLayoutMobile } = SearchResultLayout;

const components = [
	{
		name: 'info-card',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'InfoCard',
		componentData: InfoCard,
		componentProps: InfoCardProps,
	},
	{
		name: 'header-item',
		vtexApp: `vtex.store-header: 2.x`,
		componentName: 'HeaderItem',
		componentData: HeaderItem,
		componentProps: () => {
			return {};
		},
	},
	{
		name: 'product-price',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductPrice',
		componentData: ProductPrice,
		componentProps: ProductPriceProps,
	},
	{
		name: 'accepted-payment-methods',
		vtexApp: `vtex.store-footer: 2.x`,
		componentName: 'AcceptedPaymentMethods',
		componentData: AcceptedPaymentMethods,
		componentProps: AcceptedPaymentMethodsProps,
	},
	{
		name: 'flex-layout.row',
		vtexApp: `vtex.flex-layout: 0.x`,
		componentName: 'FlexLayoutRow',
		componentData: Row,
		componentProps: FlexLayoutRowProps,
	},
	{
		name: 'flex-layout.col',
		vtexApp: `vtex.flex-layout: 0.x`,
		componentName: 'FlexLayoutCol',
		componentData: Col,
		componentProps: FlexLayoutColProps,
	},
	{
		name: 'add-to-list-btn',
		vtexApp: `peer/vtex.wish-list: 1.x`,
		componentName: 'Wishlist',
		componentData: Wishlist,
		componentProps: WishlistProps,
	},
	{
		name: 'vtex.product-highlights@2.x:product-highlights',
		vtexApp: `vtex.product-highlights: 2.x`,
		componentName: 'ProductHighlights',
		componentData: ProductHighlights,
		componentProps: ProductHighlightsProps,
	},
	{
		name: 'product-highlight-text',
		vtexApp: `vtex.product-highlights: 2.x`,
		componentName: 'ProductHighlightText',
		componentData: ProductHighlightText,
		componentProps: ProductHighlightTextProps,
	},
	{
		name: 'product-highlight-wrapper',
		vtexApp: `vtex.product-highlights: 2.x`,
		componentName: 'ProductHighlightWrapper',
		componentData: ProductHighlightWrapper,
		componentProps: ProductHighlightWrapperProps,
	},
	{
		name: 'product-description',
		vtexApp: `vtex.store-components: 2.x`,
		componentName: 'ProductDescription',
		componentData: ProductDescription,
		componentProps: ProductDescriptionProps,
	},
	{
		name: 'product-images',
		vtexApp: `vtex.store-components: 2.x`,
		componentName: 'ProductImages',
		componentData: ProductImages,
		componentProps: ProductImagesProps,
	},
	{
		name: 'product-quantity',
		vtexApp: `vtex.product-quantity: 1.x`,
		componentName: 'ProductQuantity',
		componentData: ProductQuantity,
		componentProps: ProductQuantityProps,
	},
	{
		name: 'breadcrumb',
		vtexApp: `vtex.breadcrumb: 1.x`,
		componentName: 'Breadcrumb',
		componentData: Breadcrumb,
		componentProps: BreadcrumbProps,
	},
	{
		name: 'add-to-cart-button',
		vtexApp: `vtex.add-to-cart-button: 0.x`,
		componentName: 'AddToCartButton',
		componentData: AddToCartButton,
		componentProps: AddToCartButtonProps,
	},
	{
		name: 'login',
		vtexApp: `vtex.login: 2.x`,
		componentName: 'Login',
		componentData: Login,
		componentProps: LoginProps,
	},
	{
		name: 'vtex.menu@2.x:menu',
		vtexApp: `vtex.menu: 2.x`,
		componentName: 'Menu',
		componentData: Menu,
		componentProps: MenuProps,
	},
	{
		name: 'menu-item',
		vtexApp: `vtex.menu: 2.x`,
		componentName: 'MenuItem',
		componentData: MenuItem,
		componentProps: MenuItemProps,
	},
	{
		name: 'vtex.menu@2.x:submenu.accordion',
		vtexApp: `vtex.menu: 2.x`,
		componentName: 'SubmenuAccordion',
		componentData: SubmenuAccordion,
		componentProps: SubmenuAccordionProps,
	},
	//esse é component
	{
		name: 'minicart.v2',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'Minicart',
		componentData: Minicart,
		componentProps: MinicartProps,
	},
	//esse tbm
	// {
	//     name: "minicart.v2",
	//     vtexApp: [`vtex.minicart: 2.x`, `peer/vtexeurope.minicart-freeshipping-bar: 2.x`],
	//     componentName: "MinicartFixed",
	//     componentData: MinicartFixed,
	//     componentProps: MinicartFixedProps,
	// },
	{
		name: 'product-identifier.product',
		vtexApp: `vtex.product-identifier: 0.x`,
		componentName: 'ProductIdentifier',
		componentData: ProductIdentifier,
		componentProps: ProductIdentifierProps,
	},
	{
		name: 'product-summary-image',
		vtexApp: `vtex.product-summary: 2.x`,
		componentName: 'ProductSummaryImage',
		componentData: ProductSummaryImage,
		componentProps: ProductSummaryImageProps,
	},
	{
		name: 'product-summary-name',
		vtexApp: `vtex.product-summary: 2.x`,
		componentName: 'ProductSummaryName',
		componentData: ProductSummaryName,
		componentProps: ProductSummaryNameProps,
	},
	{
		name: 'vtex.store-components:product-brand',
		vtexApp: `vtex.store-components: 2.x`,
		componentName: 'ProductBrand',
		componentData: ProductBrand,
		componentProps: ProductBrandProps,
	},
	{
		name: 'rich-text',
		vtexApp: `vtex.rich-text: 0.x`,
		componentName: 'RichText',
		componentData: RichText,
		componentProps: RichTextProps,
	},
	{
		name: 'sticky-layout',
		vtexApp: `vtex.sticky-layout: 0.x`,
		componentName: 'StickyLayout',
		componentData: StickyLayout,
		// "componentProps": StickyLayoutProps
	},
	{
		name: 'image',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'Image',
		componentData: Image,
		componentProps: ImageProps,
	},
	{
		name: 'logo',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'Logo',
		componentData: Logo,
		componentProps: LogoProps,
	},
	{
		name: 'search-bar',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'SearchBar',
		componentData: SearchBar,
		componentProps: SearchBarProps,
	},
	{
		name: 'search-not-found-layout',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'SearchNotFoundLayout',
		componentData: SearchNotFoundLayout,
		componentProps: SearchNotFoundLayoutProps,
	},
	{
		name: 'not-found',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'NotFound',
		componentData: NotFound,
		componentProps: NotFoundProps,
	},
	{
		name: 'share',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'Share',
		componentData: Share,
		componentProps: ShareProps,
	},
	{
		name: 'shipping-simulator',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'ShippingSimulator',
		componentData: ShippingSimulator,
		componentProps: ShippingSimulatorProps,
	},
	{
		name: 'sku-selector',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'SkuSelector',
		componentData: SkuSelector,
		componentProps: SkuSelectorProps,
	},
	{
		name: 'vtex.menu@2.x:submenu',
		vtexApp: `vtex.menu: 2.x`,
		componentName: 'Submenu',
		componentData: Submenu,
		componentProps: SubmenuProps,
	},

	{
		name: 'product-installments',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductInstallments',
		componentData: ProductInstallments,
		componentProps: ProductInstallmentsProps,
	},
	{
		name: 'product-seller-name',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductSellerName',
		componentData: ProductSellerName,
		componentProps: ProductSellerNameProps,
	},
	{
		name: 'product-seller-name',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductSellerName',
		componentData: ProductSellerName,
		componentProps: ProductSellerNameProps,
	},
	{
		name: 'product-selling-price',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductSellingPrice',
		componentData: ProductSellingPrice,
		componentProps: ProductSellingPriceProps,
	},
	{
		name: 'product-list-price',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductListPrice',
		componentData: ProductListPrice,
		componentProps: ProductListPriceProps,
	},
	{
		name: 'product-price-savings',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductPriceSavings',
		componentData: ProductPriceSavings,
		componentProps: ProductPriceSavingsProps,
	},
	{
		name: 'product-spot-price',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductSpotPrice',
		componentData: ProductSpotPrice,
		componentProps: ProductSpotPriceProps,
	},
	{
		name: 'newsletter-form',
		vtexApp: `vtex.store-newsletter: 1.x`,
		componentName: 'NewsletterForm',
		componentData: NewsletterForm,
		componentProps: NewsletterFormProps,
	},
	{
		name: 'newsletter-submit',
		vtexApp: `vtex.store-newsletter: 1.x`,
		componentName: 'NewsletterSubmit',
		componentData: NewsletterSubmit,
		componentProps: NewsletterSubmitProps,
	},
	{
		name: 'newsletter-checkbox-confirmation',
		vtexApp: `vtex.store-newsletter: 1.x`,
		componentName: 'NewsletterCheckboxConfirmation',
		componentData: NewsletterCheckboxConfirmation,
		componentProps: NewsletterCheckboxConfirmationProps,
	},
	{
		name: 'newsletter-input-email',
		vtexApp: `vtex.store-newsletter: 1.x`,
		componentName: 'NewsletterInputEmail',
		componentData: NewsletterInputEmail,
		componentProps: NewsletterInputEmailProps,
	},
	{
		vtexApp: `vtex.store-newsletter: 1.x`,
		componentName: 'NewsletterInputName',
		componentData: NewsletterInputName,
		componentProps: NewsletterInputNameProps,
	},
	{
		name: 'drawer',
		vtexApp: `vtex.store-drawer: 0.x`,
		componentName: 'Drawer',
		componentData: Drawer,
		componentProps: DrawerProps,
	},
	{
		name: 'drawer-header',
		vtexApp: `vtex.store-drawer: 0.x`,
		componentName: 'DrawerHeader',
		componentData: DrawerHeader,
		componentProps: DrawerHeaderProps,
	},
	{
		name: 'shelf.relatedProducts',
		vtexApp: `vtex.shelf: 1.x`,
		templates: RelatedProductsTemplates,
		componentName: 'RelatedProducts',
		componentData: RelatedProducts,
		componentProps: RelatedProductsProps,
	},
	{
		name: 'vtex.store-components:product-name',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'ProductName',
		componentData: ProductName,
		componentProps: ProductNameProps,
	},

	{
		name: 'social-networks',
		vtexApp: `vtex.store-footer: 2.x`,
		componentName: 'SocialNetwork',
		componentData: SocialNetwork,
		componentProps: SocialNetworkProps,
	},
	{
		name: 'stack-layout',
		vtexApp: `vtex.stack-layout: 0.x`,
		classVtexApp: 'vtex-stack-layout-0-x',
		componentName: 'StackLayout',
		componentData: StackLayout,
		componentProps: StackLayoutProps,
	},
	{
		name: 'product-specification',
		vtexApp: `vtex.product-specifications: 1.x`,
		componentName: 'ProductSpecification',
		componentData: ProductSpecification,
		componentProps: ProductSpecificationProps,
	},
	{
		name: 'product-specification-group',
		vtexApp: `vtex.product-specifications: 1.x`,
		componentName: 'ProductSpecificationGroup',
		componentData: ProductSpecificationGroup,
		componentProps: ProductSpecificationGroupProps,
	},
	{
		name: 'product-specification-text',
		vtexApp: `vtex.product-specifications: 1.x`,
		componentName: 'ProductSpecificationText',
		componentData: ProductSpecificationText,
		componentProps: ProductSpecificationTextProps,
	},
	{
		name: 'product-specification-values',
		vtexApp: `vtex.product-specifications: 1.x`,
		componentName: 'ProductSpecificationValues',
		componentData: ProductSpecificationValues,
		componentProps: ProductSpecificationValuesProps,
	},
	{
		name: 'list-context.image-list',
		vtexApp: `vtex.store-image: 0.x`,
		componentName: 'StoreImageList',
		componentData: StoreImageList,
		componentProps: StoreImageListProps,
	},
	{
		name: 'filter-navigator.v3',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'FilterNavigatorV3',
		componentData: FilterNavigatorV3,
		componentProps: FilterNavigatorV3Props,
	},
	{
		name: 'search-content',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'SearchContent',
		componentData: SearchContent,
		componentProps: SearchContentProps,
	},
	{
		name: 'gallery',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'Gallery',
		componentData: Gallery,
		componentProps: GalleryProps,
	},
	{
		name: 'SearchTitleV2',
		// vtexApp: `search-result: 3.x`,
		componentName: 'SearchTitleV2',
		componentData: SearchTitleV2,
		componentProps: SearchTitleV2Props,
	},
	{
		name: 'TotalProductsV2',
		componentName: 'TotalProductsV2',
		componentData: TotalProductsV2,
		componentProps: TotalProductsV2Props,
	},
	{
		name: 'OrderByV2',
		componentName: 'OrderByV2',
		componentData: OrderByV2,
		componentProps: OrderByV2Props,
	},
	{
		name: 'drawer-close-button',
		vtexApp: `vtex.store-drawer: 0.x`,
		classVtexApp: 'vtex-store-drawer-0-x',
		componentName: 'DrawerCloseButton',
		componentData: DrawerCloseButton,
		componentProps: DrawerCloseButtonProps,
	},
	{
		name: 'disclosure-content',
		vtexApp: `vtex.disclosure-layout: 1.x`,
		componentName: 'DisclosureContent',
		componentData: DisclosureContent,
		componentProps: DisclosureContentProps,
	},
	{
		name: 'disclosure-layout',
		vtexApp: `vtex.disclosure-layout: 1.x`,
		componentName: 'DisclosureLayout',
		componentData: DisclosureLayout,
		componentProps: DisclosureLayoutProps,
	},
	{
		name: 'disclosure-layout-group',
		vtexApp: `vtex.disclosure-layout: 1.x`,
		componentName: 'DisclosureLayoutGroup',
		componentData: DisclosureLayoutGroup,
		componentProps: DisclosureLayoutGroupProps,
	},
	{
		name: 'disclosure-state-indicator',
		vtexApp: `vtex.disclosure-layout: 1.x`,
		componentName: 'DisclosureStateIndicator',
		componentData: DisclosureStateIndicator,
		componentProps: DisclosureStateIndicatorProps,
	},
	{
		name: 'disclosure-trigger',
		vtexApp: `vtex.disclosure-layout: 1.x`,
		componentName: 'DisclosureTrigger',
		componentData: DisclosureTrigger,
		componentProps: DisclosureTriggerProps,
	},
	{
		name: 'minicart-base-content',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'MinicartBaseContent',
		componentData: MinicartBaseContent,
		componentProps: MinicartBaseContentProps,
	},
	{
		name: 'modal-actions.close',
		vtexApp: `vtex.modal-layout: 0.x`,
		componentName: 'ModalActionsClose',
		componentData: ModalActionsClose,
		componentProps: ModalActionsCloseProps,
	},
	{
		name: 'minicart-product-list',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'MinicartProductList',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'product-list',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'ProductList',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'product-list-content-mobile',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListContentMobile',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'product-list-image',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListImage',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'vtex.product-list:product-name',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListProductName',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'remove-button',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListRemoveButton',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'product-variations',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListProductVariations',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'vtex.product-list:price',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListPrice',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'availability-notify',
		vtexApp: `peer/vtex.availability-notify: 1.x"`,
		componentName: 'AvailabilityNotify',
		componentData: AvailabilityNotify,
		componentProps: AvailabilityNotifyProps,
	},
	{
		name: 'condition-layout.product',
		vtexApp: `vtex.condition-layout: 2.x`,
		componentName: 'ConditionLayoutProduct',
		componentData: ConditionLayoutProduct,
		componentProps: ConditionLayoutProductProps,
	},
	{
		name: 'quantity-selector',
		vtexApp: `vtex.product-list: 0.x`,
		componentName: 'MinicartProductListQuantitySelector',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'minicart-summary',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'MinicartSummary',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'minicart-empty-state',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'MinicartEmptyState',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'minicart-checkout-button',
		vtexApp: `vtex.minicart: 2.x`,
		componentName: 'MinicartCheckoutButton',
		componentData: null,
		componentProps: null,
	},
	// {
	//     name: "minicart-bar",
	//     vtexApp: `peer/vtexeurope.minicart-freeshipping-bar: 2.x`,
	//     componentName: "MinicartBar",
	//     componentData: null,
	//     componentProps: null,
	// },
	{
		name: 'checkout-summary.compact',
		vtexApp: `vtex.checkout-summary: 0.x`,
		componentName: 'CheckoutSummaryCompact',
		componentData: null,
		componentProps: null,
	},
	{
		name: 'summary-totalizers',
		vtexApp: `vtex.checkout-summary: 0.x`,
		componentName: 'CheckoutSummaryTotalizers',
		componentData: null,
		componentProps: null,
	},
	// {
	//   compDictName: "ModalContent",
	//   name: "modal-content",
	//   vtexApp: `vtex.modal-layout: 0.x`,
	//   componentName: "ModalContentClose",
	//   componentData: ModalContentClose,
	//   componentProps: ModalContentCloseProps,
	// },
	{
		name: 'modal-layout',
		vtexApp: `vtex.modal-layout: 0.x`,
		componentName: 'ModalLayout',
		componentData: ModalLayout,
		componentProps: ModalLayoutProps,
	},
	// {
	//   name: "modal-header",
	//   vtexApp: `vtex.modal-layout: 0.x`,
	//   componentName: "ModalHeader",
	//   componentData: ModalHeader,
	//   componentProps: ModalHeaderProps,
	// },
	{
		name: 'modal-trigger',
		vtexApp: `vtex.modal-layout: 0.x`,
		componentName: 'ModalTrigger',
		componentData: ModalTrigger,
		componentProps: ModalTriggerProps,
	},
	{
		name: 'tab-layout',
		vtexApp: `vtex.tab-layout": "0.x`,
		componentName: 'TabLayout',
		componentData: TabLayout,
		componentProps: TabLayoutProps,
	},
	{
		name: 'tab-list',
		vtexApp: `vtex.tab-layout": 0.x`,
		componentName: 'TabList',
		componentData: TabList,
		componentProps: TabListProps,
	},
	{
		name: 'tab-list.item',
		vtexApp: `vtex.tab-layout": 0.x`,
		componentName: 'TabListItem',
		componentData: TabListItem,
		componentProps: TabListItemProps,
	},
	{
		name: 'tab-content',
		vtexApp: `vtex.tab-layout": 0.x`,
		componentName: 'TabContent',
		componentData: TabContent,
		componentProps: TabContentProps,
	},
	{
		name: 'tab-content.item',
		vtexApp: `vtex.tab-layout": 0.x`,
		componentName: 'TabContentItem',
		componentData: TabContentItem,
		componentProps: TabContentItemProps,
	},
	{
		name: 'link',
		vtexApp: `vtex.store-link": 0.x`,
		componentName: 'Link',
		componentData: Link,
		componentProps: LinkProps,
	},
	{
		name: 'product-summary.shelf',
		vtexApp: `vtex.product-summary: 2.x`,
		componentName: 'ProductSummaryShelfComponent',
		componentData: ProductSummary,
		componentProps: ProductSummaryProps,
	},
	{
		name: 'product-rating-summary.vtex',
		vtexApp: `peer/vtex.reviews-and-ratings: 3.x`,
		componentName: 'RatingSummary',
		componentData: RatingSummary,
		componentProps: RatingSummaryProps,
	},
	{
		name: 'product-reviews.vtex',
		vtexApp: `peer/vtex.reviews-and-ratings: 3.x`,
		componentName: 'Reviews',
		componentData: Reviews,
		componentProps: ReviewsProps,
	},
	{
		name: 'buy-together',
		vtexApp: `maeztraio.buy-together: 1.x`,
		componentName: 'CompreJunto',
		componentData: CompreJunto,
		componentProps: BuyTogetherProps,
	},
	{
		name: 'product-gifts',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'ProductGifts',
		componentData: ProductGifts,
		componentProps: ProductGiftsProps,
	},
	{
		name: 'gift-text',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'GiftText',
		componentData: GiftText,
		componentProps: GiftTextProps,
	},
	{
		name: 'product-gift-list',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'ProductGiftList',
		componentData: ProductGiftList,
		componentProps: ProductGiftListProps,
	},
	{
		name: 'gift-name',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'GiftName',
		componentData: GiftName,
		componentProps: GiftNameProps,
	},
	{
		name: 'gift-image',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'GiftImage',
		componentData: GiftImage,
		componentProps: GiftImageProps,
	},
	{
		name: 'gift-description',
		vtexApp: `vtex.product-gifts: 0.x`,
		componentName: 'GiftDescription',
		componentData: GiftDescription,
		componentProps: GiftDescriptionProps,
	},
	{
		name: 'responsive-layout.desktop',
		vtexApp: `vtex.responsive-layout: 0.x`,
		componentName: 'ResponsiveLayoutDesktop',
		componentData: ResponsiveLayoutDesktop,
		componentProps: ResponsiveLayoutDesktopProps,
	},
	{
		name: 'responsive-layout.mobile',
		vtexApp: `vtex.responsive-layout: 0.x`,
		componentName: 'ResponsiveLayoutMobile',
		componentData: ResponsiveLayoutMobile,
		componentProps: ResponsiveLayoutMobileProps,
	},
	{
		name: 'list-context.info-card-list',
		vtexApp: `vtex.info-card-list: 0.x`,
		componentName: 'InfoCardList',
		componentData: InfoCardList,
		componentProps: InfoCardListProps,
	},
	{
		name: 'modal-header',
		vtexApp: `vtex.modal-layout: 0.x`,
		componentName: 'ModalHeader',
		componentData: ModalHeader,
		componentProps: ModalHeaderProps,
	},
	{
		name: 'modal-content',
		vtexApp: `vtex.modal-layout: 0.x`,
		componentName: 'ModalContent',
		componentData: ModalContent,
		componentProps: ModalContentProps,
	},
	{
		name: 'list-context-renderer',
		vtexApp: `vtex.list-context": 0.x`,
		componentName: 'ListContextRenderer',
		componentData: ListContextRenderer,
		componentProps: ListContextRendererProps,
	},
	{
		name: 'back-to-top-button',
		vtexApp: `vtex.store-components: 3.x`,
		componentName: 'BackToTopButton',
		componentData: BackToTopButton,
		componentProps: BackToTopButtonProps,
	},
	/** ICONES */
	//icon
	{
		name: 'icon',
		componentName: 'Icon',
		componentData: Icon,
		componentProps: IconProps,
	},
	{
		name: 'icon-cart',
		componentName: 'IconCart',
		componentData: IconCart,
		componentProps: IconCartProps,
	},
	{
		name: 'icon-close',
		componentName: 'IconClose',
		componentData: IconClose,
		componentProps: IconCloseProps,
	},
	{
		name: 'icon-delete',
		componentName: 'IconDelete',
		componentData: IconDelete,
		componentProps: IconDeleteProps,
	},
	{
		name: 'icon-caret',
		componentName: 'IconCaret',
		componentData: IconCaret,
		componentProps: IconCaretProps,
	},
	{
		name: 'experimental__visibility-layout',
		vtexApp: `vtex.visibility-layout: 0.x`,
		componentName: 'VisibilityLayout',
		componentData: VisibilityLayout,
		componentProps: VisibilityLayoutProps,
	},
	{
		name: 'disposition-layout',
		vtexApp: `peer/vtex.disposition-layout: 3.x`,
		componentName: 'DispositionLayout',
		componentData: DispositionLayout,
		componentProps: DispositionLayoutProps,
	},
	{
		name: 'video',
		vtexApp: `vtex.store-video": 1.x`,
		componentName: 'Video',
		componentData: Video,
		componentProps: VideoProps,
	},
	{
		name: 'product-installment-list',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductInstallmentsList',
		componentData: ProductInstallmentsList,
		componentProps: ProductInstallmentsListProps,
	},
	{
		name: 'product-installment-list-item',
		vtexApp: `vtex.product-price: 1.x`,
		componentName: 'ProductInstallmentsListItem',
		componentData: ProductInstallmentsListItem,
		componentProps: ProductInstallmentsListItemProps,
	},
	{
		name: 'link-seller',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'LinkSeller',
		componentData: LinkSeller,
		componentProps: LinkSellerProps,
	},
	{
		name: 'seller-table',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerTable',
		componentData: SellerTable,
		componentProps: SellerTableProps,
	},
	{
		name: 'seller-simulate-shipping',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerSimulateShipping',
		componentData: SellerSimulateShipping,
		componentProps: SellerSimulateShippingProps,
	},
	{
		name: 'seller-head',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerHead',
		componentData: SellerHead,
		componentProps: SellerHeadProps,
	},
	{
		name: 'seller-head-cell',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerHeadCell',
		componentData: SellerHeadCell,
		componentProps: SellerHeadCellProps,
	},
	{
		name: 'seller-body',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerBody',
		componentData: SellerBody,
		componentProps: SellerBodyProps,
	},
	{
		name: 'seller-row',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerRow',
		componentData: SellerRow,
		componentProps: SellerRowProps,
	},
	{
		name: 'seller-name',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerName',
		componentData: SellerName,
		componentProps: SellerNameProps,
	},
	{
		name: 'seller-price',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerPrice',
		componentData: SellerPrice,
		componentProps: SellerPriceProps,
	},
	{
		name: 'seller-shipping',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerShipping',
		componentData: SellerShipping,
		componentProps: SellerShippingProps,
	},
	{
		name: 'seller-price-with-shipping',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerPriceWithShipping',
		componentData: SellerPriceWithShipping,
		componentProps: SellerPriceWithShippingProps,
	},
	{
		name: 'seller-add-to-cart',
		vtexApp: `vtex.seller-selector:0.x`,
		componentName: 'SellerAddToCart',
		componentData: SellerAddToCart,
		componentProps: SellerAddToCartProps,
	},
	{
		name: 'tab-list.item.children',
		vtexApp: `vtex.tab-layout:0.x`,
		componentName: 'TabListItemChildren',
		componentData: TabListItemChildren,
		componentProps: TabListItemChildrenProps,
	},
	{
		name: 'form',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'Form',
		componentData: Form,
		componentProps: FormProps,
	},
	{
		name: 'form-input.checkbox',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormInputCheckbox',
		componentData: FormInputCheckbox,
		componentProps: FormInputCheckboxProps,
	},
	{
		name: 'form-input.dropdown',
		vtexApp: `vtex.store-form:.x`,
		componentName: 'FormInputDropdown',
		componentData: FormInputDropdown,
		componentProps: FormInputDropdownProps,
	},
	{
		name: 'form-input.radiogroup',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormInputRadiogroup',
		componentData: FormInputRadiogroup,
		componentProps: FormInputRadiogroupProps,
	},
	{
		name: 'form-input.textarea',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormInputTextarea',
		componentData: FormInputTextArea,
		componentProps: FormInputTextareaProps,
	},
	{
		name: 'form-input.text',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormInputText',
		componentData: FormInputText,
		componentProps: FormInputTextProps,
	},
	{
		name: 'form-field-group',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormFieldGroup',
		componentData: FormFieldGroup,
		componentProps: FormFieldGroupProps,
	},
	{
		name: 'form-input.upload',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormInputUpload',
		componentData: FormInputUpload,
		componentProps: FormInputUploadProps,
	},
	{
		name: 'form-submit',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormSubmit',
		componentData: FormSubmit,
		componentProps: FormSubmitProps,
	},
	{
		name: 'form-success',
		vtexApp: `vtex.store-form:0.x`,
		componentName: 'FormSuccess',
		componentData: FormSuccess,
		componentProps: FormSuccessProps,
	},
	{
		name: 'mega-menu',
		vtexApp: `peer/vtex.mega-menu:2.x`,
		componentName: 'MegaMenu',
		componentData: MegaMenu,
		componentProps: MegaMenuProps,
	},
	{
		name: 'mega-menu-go-back-btn',
		vtexApp: `peer/vtex.mega-menu:2.x`,
		componentName: 'MegaMenuGoBackBtn',
		componentData: MegaMenuGoBackBtn,
		componentProps: MegaMenuGoBackBtnProps,
	},
	{
		name: 'mega-menu-trigger-btn',
		vtexApp: `peer/vtex.mega-menu:2.x`,
		componentName: 'MegaMenuTriggerBtn',
		componentData: MegaMenuTriggerBtn,
		componentProps: MegaMenuTriggerBtnProps,
	},
	{
		name: 'search-fetch-previous',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'SearchFetchPrevious',
		componentData: SearchFetchPrevious,
		componentProps: SearchFetchPreviousProps,
	},
	{
		name: 'search-fetch-more',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'SearchFetchMore',
		componentData: SearchFetchMore,
		componentProps: SearchFetchMoreProps,
	},
	{
		name: 'search-fetch-previous',
		vtexApp: `vtex.search-result: 3.x`,
		componentName: 'SearchFetchPrevious',
		componentData: SearchFetchPrevious,
		componentProps: SearchFetchPreviousProps,
	},
	{
		name: 'overlay-trigger',
		vtexApp: `vtex.overlay-layout: 0.x`,
		componentName: 'OverlayTrigger',
		componentData: OverlayTrigger,
		componentProps: OverlayTriggerProps,
	},
	{
		name: 'overlay-layout',
		vtexApp: `vtex.overlay-layout: 0.x`,
		componentName: 'OverlayLayout',
		componentData: OverlayLayout,
		componentProps: OverlayLayoutProps,
	},
	{
		name: 'product-rating-inline',
		vtexApp: `peer/vtex.reviews-and-ratings: 3.x`,
		componentName: 'ProductRatingInline',
		componentData: ProductRatingInline,
		componentProps: ProductRatingInlineProps,
	},
	{
		name: 'product-summary-sku-selector',
		vtexApp: `vtex.product-summary: 2.x`,
		componentName: 'ProductSummarySkuSelector',
		componentData: ProductSummarySkuSelector,
		componentProps: ProductSummarySkuSelectorProps,
	},

	/* DAQUI PRA BAIXO SÓ TEMPLATES */
	/*--------------------------------------------*/
	/*--------------------------------------------*/
	/*--------------------------------------------*/
	/*--------------------------------------------*/
	/*--------------------------------------------*/
	/*--------------------------------------------*/
	{
		componentName: 'StoreMenuDesktop',
		templates: StoreMenuDesktopTemplates,
		componentData: FlexLayout.Row,
		componentProps: StoreMenuDesktopProps,
	},
	{
		componentName: 'StoreMenuMobile',
		templates: StoreMenuMobileTemplates,
		componentData: Menu,
		componentProps: StoreMenuMobileProps,
	},
	{
		componentName: 'StoreMenuMobileItem',
	},
	//product description group
	{
		componentName: 'ProductDescriptionGroup',
		templates: ProductDescriptionGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: ProductDescriptionGroupProps,
	},
	{
		componentName: 'BreadcrumbGroup',
		templates: BreadcrumbGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: BreadcrumbGroupProps,
	},
	{
		componentName: 'SellerSelector',
		templates: SellerSelectorTemplates,
		componentData: FlexLayout.Row,
		componentProps: SellerSelectorProps,
	},
	{
		componentName: 'VideoGroup',
		templates: VideoGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: VideoGroupProps,
	},
	{
		componentName: 'InstitutionalGroup',
		templates: InstitutionalGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: InstitutionalGroupProps,
	},
	{
		componentName: 'RichTextRow',
		templates: RichTextRowTemplates,
		componentData: FlexLayout.Row,
		componentProps: RichTextRowProps,
	},
	{
		componentName: 'SearchNotFoundGroup',
		templates: SearchNotFoundGroupTemplates,
		componentData: SearchNotFoundLayout,
		componentProps: SearchNotFoundGroupProps,
	},
	{
		componentName: 'ReviewsGroup',
		templates: ReviewsGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: ReviewsGroupProps,
	},
	{
		componentName: 'BuyTogetherGroup',
		templates: BuyTogetherTemplates,
		componentData: FlexLayout.Row,
		componentProps: BuyTogetherGroupProps,
	},
	{
		componentName: 'ProductSpecificationSection',
		templates: ProductSpecificationSectionTemplates,
		componentData: FlexLayout.Row,
		componentProps: ProductSpecificationSectionProps,
	},
	{
		componentName: 'MinicartGroup',
		templates: MinicartGroupTemplates,
		componentProps: MinicartGroupProps,
		componentData: Minicart,
	},
	{
		name: 'ModalNewsletter',
		componentName: 'ModalNewsletter',
		templates: ModalNewsletterTemplates,
		componentData: '',
		componentProps: ModalNewsletterProps,
	},
	{
		name: 'search-result-layout.desktop',
		vtexApp: `vtex.search-result: 3.x`,
		templates: SearchResultLayoutDesktopTemplates,
		componentName: 'SearchResultLayoutDesktop',
		componentData: SearchResultLayoutDesktop,
		componentProps: SearchResultLayoutDesktopProps,
	},
	{
		name: 'search-result-layout.mobile',
		vtexApp: `vtex.search-result: 3.x`,
		templates: SearchResultLayoutMobileTemplates,
		componentName: 'SearchResultLayoutMobile',
		componentData: SearchResultLayoutMobile,
		componentProps: SearchResultLayoutMobileProps,
	},
	{
		name: 'product-summary.shelf',
		vtexApp: `vtex.product-summary: 2.x`,
		templates: ProductSummaryShelfTemplates,
		componentName: 'ProductSummaryShelf',
		componentData: ProductSummary,
		componentProps: ProductSummaryShelfProps,
	},
	{
		name: 'list-context.product-list',
		vtexApp: `vtex.product-summary: 2.x`,
		templates: ProductSummaryListTemplates,
		componentName: 'ProductSummaryList',
		componentData: ProductSummaryList,
		componentProps: ProductSummaryListProps,
	},
	{
		name: 'BannerSectionGroup',
		componentName: 'BannerSectionGroup',
		templates: BannerSectionGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: BannerSectionGroupProps,
	},
	{
		name: 'RichTextVideo',
		componentName: 'RichTextVideo',
		templates: RichTextVideoTemplates,
		componentData: FlexLayout.Row,
		componentProps: RichTextVideoProps,
	},
	{
		name: 'TipbarGroup',
		componentName: 'TipbarGroup',
		templates: TipbarGroupTemplates,
		componentData: FlexLayout.Row,
		componentProps: TipbarGroup,
	},
	{
		name: 'BrandGroup',
		templates: BrandGroupTemplates,
		componentName: 'BrandGroup',
		componentData: FlexLayout.Row,
		componentProps: BrandGroupProps,
	},
	{
		name: 'TopHeader',
		templates: TopHeaderTemplates,
		componentName: 'TopHeader',
		componentData: FlexLayout.Row,
		componentProps: TopHeaderProps,
	},
	{
		name: 'ProductImagesDetailsGroup',
		templates: ProductImagesDetailsTemplates,
		componentName: 'ProductImagesDetailsGroup',
		componentData: FlexLayout.Row,
		componentProps: ProductImagesDetailsGroup,
	},
	{
		name: 'header-layout.desktop',
		vtexApp: `vtex.store-header: 2.x`,
		templates: HeaderDesktopTemplates,
		componentName: 'HeaderDesktop',
		componentData: HeaderDesktop,
		componentProps: HeaderDesktopProps,
	},
	{
		name: 'header-layout.mobile',
		vtexApp: `vtex.store-header: 2.x`,
		templates: HeaderMobileTemplates,
		componentName: 'HeaderMobile',
		componentData: HeaderMobile,
		componentProps: HeaderMobileProps,
	},
	{
		name: 'footer-layout.desktop',
		vtexApp: `vtex.store-footer: 2.x`,
		templates: FooterDesktopTemplates,
		componentName: 'FooterDesktop',
		componentData: FooterDesktop,
		componentProps: FooterDesktopProps,
	},
	{
		name: 'footer-layout.mobile',
		vtexApp: `vtex.store-footer: 2.x`,
		templates: FooterMobileTemplates,
		componentName: 'FooterMobile',
		componentData: FooterMobile,
		componentProps: FooterMobileProps,
	},
	{
		name: 'newsletter-form',
		vtexApp: `vtex.store-newsletter: 1.x`,
		templates: NewsletterTemplates,
		componentName: 'Newsletter',
		componentData: NewsletterForm,
		componentProps: NewsletterProps,
	},
	{
		name: 'slider-layout',
		vtexApp: `vtex.slider-layout: 0.x`,
		templates: SliderLayoutTemplates,
		componentName: 'SliderLayout',
		componentData: SliderLayout,
		componentProps: SliderLayoutProps,
	},
];

export default components;
